import { useEffect, useState } from "react";
import "./style.css";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { apiCreateCustomer } from "../../../api/master";
// import { apiCity, apiState } from "../../../api/stateAndCity";
import customerSchema from "../../../validations/customer";
import { inputOnlyNumber } from "../../../utils";

function CompanyAdd(props) {
  // const [stateValue,setStateValue] = useState([]);
  // const [city,setCity] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [selectedcode, setSelectedCode] = useState("");
  const [shownew, setShownew] = useState(false);

  // const handlecodeChange = (selectedcode) => {
  //   setSelectedCode(selectedcode);
  // };

  // const stateListMap = stateValue?.flatMap(el => {
  //   return {
  //     value: el?.state_id,
  //     label: el.name,
  //   };
  // });

  // const filterCityName = city?.filter(el => Number(el?.state_id) === Number(selectedcode?.value));
  // const cityListMap = filterCityName?.flatMap(el => {
  //       return {
  //           value: el?.city_id,
  //           label: el.city,
  //       };
  // });

  const companyFormik = useFormik({
    initialValues: {
      customer_name: "",
      customer_mobile: "",
      cust_address: "",
      // "cust_state_id": "",
      // "cust_city_id": "",
      // "cust_pincode": ""
    },
    validationSchema: customerSchema.validateCompanyAdd(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      const decod = {
        customer_name: values.customer_name,
        cust_address: values.cust_address,
        customer_mobile: values.customer_mobile,
        // cust_state_id: Number(values.cust_state_id),
        // cust_city_id:Number(values.cust_city_id),
        // cust_pincode:Number(values.cust_pincode)
      };
      await apiCreateCustomer(decod)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          setShownew(true);
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
        });
    },

    onReset: async (values) => {
      setSelectedCode(null);
      companyFormik.resetForm();
      setShownew(false);
      setSuccess("");
    },
  });

  // async function getStateAndCity() {
  //   await apiState().then(result => setStateValue(result.data.data.list));
  //   await apiCity().then(result => setCity(result?.data?.data.list));
  // }

  // useEffect(function () {
  //   getStateAndCity();
  // }, []);

  useEffect(
    function () {
      const timer = setTimeout(() => {
        setSuccess("");
        setError("");
      }, 5000);
      return () => clearTimeout(timer);
    },
    [success, error]
  );

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Add Customer
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={companyFormik.handleSubmit}
          onReset={companyFormik.handleReset}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="customer_name">
              Customer Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="customer_name"
              {...companyFormik.getFieldProps("customer_name")}
            />
            {companyFormik.errors.customer_name && shownew !== true ? (
              <div className="text-danger small">
                {companyFormik.errors.customer_name}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="customer_mobile">Mobile No</label>
            <input
              type="text"
              onKeyDown={inputOnlyNumber}
              maxLength={13}
              className="form-control"
              id="customer_mobile"
              {...companyFormik.getFieldProps("customer_mobile")}
            />
            {companyFormik.errors.customer_mobile && shownew !== true ? (
              <div className="text-danger small">
                {companyFormik.errors.customer_mobile}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="cust_address">Customer Address</label>
            <textarea
              type="text"
              maxLength={100}
              className="form-control"
              id="cust_address"
              {...companyFormik.getFieldProps("cust_address")}
            />
            {companyFormik.errors.cust_address && shownew !== true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_address}
              </div>
            ) : null}
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="cust_state_id">
              State <span className="text-danger">*</span>
            </label>
            <Select
              options={stateListMap}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  minHeight: "0px",
                }),
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
                input: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }),
                dropdownIndicator: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
              }}
              value={selectedcode}
              classNamePrefix="react-select"
              tabSelectsValue
              onChange={(selectedOption) => {
                handlecodeChange(selectedOption);
                companyFormik.setFieldValue("cust_state_id", selectedOption.value);
              }}
              name="cust_state_id"
            />
            {companyFormik.errors.cust_state_id && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_state_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="cust_city_id">
              City <span className="text-danger">*</span>
            </label>
            <select
              type="text"
              className="form-select"
              id="item_unit"
              disabled={cityListMap.length === 0 ? true : false}
              {...companyFormik.getFieldProps("cust_city_id")}
              >
              <option value="" hidden>
                Select...
              </option>
              {cityListMap.map((list) => {
                  return <option value={list.value}>{list.label}</option>;
              })}
            </select>
            {companyFormik.errors.cust_city_id && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_city_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="comp_pincode">
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={9}
              className="form-control"
              id="cust_pincode"
              {...companyFormik.getFieldProps("cust_pincode")}
            />
            {companyFormik.errors.cust_pincode && shownew != true ? (
              <div className="text-danger small">
                {companyFormik.errors.cust_pincode}
              </div>
            ) : null}
          </div> */}
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="reset"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  type="reset"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default CompanyAdd;
